import React from 'react';
import ReactDOM from 'react-dom';
import 'rsuite/dist/styles/rsuite-default.css';
import './index.css';
import App from './App';
ReactDOM.render(<App />, document.getElementById('root'));
